// extracted by mini-css-extract-plugin
export default {"loaderWrap":"loaders_loaderWrap__zO6KP","loader":"loaders_loader__Y2NQc","rotate":"loaders_rotate__+VEWO","ball1":"loaders_ball1__tKO2R","ball2":"loaders_ball2__Rj2Hf"};